import { render, staticRenderFns } from "./history-comp.vue?vue&type=template&id=2f9772ad&scoped=true&"
import script from "./history-comp.vue?vue&type=script&lang=js&"
export * from "./history-comp.vue?vue&type=script&lang=js&"
import style0 from "./history-comp.vue?vue&type=style&index=0&id=2f9772ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9772ad",
  null
  
)

export default component.exports